export default __webpack_public_path__ + "static/media/32.d6427d96.png";